import React, { Component } from "react";
import { Col, Row, Media, Button } from "reactstrap";
import { dateToString } from "../../helpers/utils";

import dropdownDown from "../../images/dropdownDown.png";

import appClasses from "../../App.module.scss";
import classes from "./ResultDataRow.module.scss";

class ResultDataRow extends Component {
  render() {
    return (
      <Row className={classes.moreDetailsRow}>
        <Col lg="1" md="2" />
        <Col lg="11" md="10" className={classes.moreDetailsCol}>
          <span>
            תאריך פירסום: {dateToString(new Date(this.props.publishAt))}
          </span>
          {this.props.resultsLength > 1 ? (
            <div className={appClasses.leftDiv}>
              <Button
                color="link"
                onClick={() => this.props.toggleHeandler()}
                className={appClasses.moreResults}
              >
                בעמוד זה קיימות {this.props.resultsLength - 1} תוצאות נוספות
                <Media
                  src={dropdownDown}
                  alt="עוד תוצאות"
                  className={appClasses.moreResultsImg}
                />
              </Button>
            </div>
          ) : (
            ""
          )}
        </Col>
      </Row>
    );
  }
}

export default ResultDataRow;
